import { Component, OnInit, ViewChild, EventEmitter, Output } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.css"]
})
export class ConfirmModalComponent implements OnInit {

  private ngbModalRef: NgbModalRef;
  countDay: FormControl = new FormControl();
  formGroup: FormGroup = new FormGroup({
    countDay: this.countDay
  });
  center: any;
  constructor(private modalService: NgbModal) {

  }
  @ViewChild("content") content: any;
  @Output() cancelEvent = new EventEmitter();

  @Output() okEvent = new EventEmitter();

  public ngOnInit(): void {

  }
  public show(): void {
    this.ngbModalRef = this.modalService.open(this.content, { centered: true, size: 'lg' });
  }

  public hide(): void {
    this.ngbModalRef.close();
  }

  ok(): void {
    this.okEvent.emit();
    this.hide();
  }

  cancel(): void {
    this.cancelEvent.emit();
    this.hide();
  }
}
